export const mCustomCiphers = {
    romComs: 'romComs',
    bucky: 'bucky',
    janus: 'janus',
    medusa: 'medusa',
    geryon: 'geryon',
    kalypso: 'kalypso',
    hades: 'hades',
    prince: 'prince',
    tinder: 'tinder',
};
